var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoContentsIcon = function SvgNoContentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DDE2",
    d: "M36 0a36 36 0 1 0 36 36A36.045 36.045 0 0 0 36 0m-6.349 34.04a2.77 2.77 0 1 1-3.918 3.92l-3.58-3.584-3.578 3.583a2.77 2.77 0 1 1-3.919-3.918l3.583-3.58-3.583-3.579a2.77 2.77 0 1 1 3.919-3.918l3.579 3.583 3.58-3.583a2.77 2.77 0 0 1 3.917 3.918l-3.582 3.58zM36 58.155a4.154 4.154 0 1 1 0-8.308 4.154 4.154 0 0 1 0 8.308M57.344 34.04a2.77 2.77 0 1 1-3.919 3.918l-3.579-3.583-3.58 3.583a2.77 2.77 0 1 1-3.917-3.918l3.582-3.58-3.582-3.579a2.77 2.77 0 1 1 3.918-3.918l3.58 3.583 3.578-3.583a2.773 2.773 0 0 1 4.52.899 2.77 2.77 0 0 1-.601 3.02l-3.583 3.579z"
  })));
};
export default SvgNoContentsIcon;